// set/get sessionStorage

let init = false;

let assistantWorkInfo = {
    currentPageIndex: 0,
    homeworkIdList: []
};

const initAssistantWorkInfo = () => {
    assistantWorkInfo = {
        currentPageIndex: window.sessionStorage.assistantWorkInfo ? JSON.parse(window.sessionStorage.assistantWorkInfo).currentPageIndex : 0, //eslint-disable-line
        homeworkIdList: window.sessionStorage.assistantWorkInfo ? JSON.parse(window.sessionStorage.assistantWorkInfo).homeworkIdList : [] //eslint-disable-line
    };
};

const setAssistantWorkInfo = part => {
    if (!window.sessionStorage) {
        return false;
    }
    const storage = window.sessionStorage;
    assistantWorkInfo = Object.assign({}, assistantWorkInfo, part);
    storage.setItem('assistantWorkInfo', JSON.stringify(assistantWorkInfo));
};

const getAssistantWorkInfo = () => {
    if (!window.sessionStorage) {
        return false;
    }
    if (!init) {
        init = true;
        initAssistantWorkInfo();
    }
    return assistantWorkInfo;
};

export {
    setAssistantWorkInfo,
    getAssistantWorkInfo
};
